import { PillColor, STATUS_DB } from '../types/status.type';
import type { StatusDb } from '../types/status.type';

export const ENABLED_SWIFT_DOWNLOAD_STATUS: StatusDb[] = [
  STATUS_DB.TRANSFERENCIA_ENVIADA,
  STATUS_DB.TRANSFERENCIA_EXITOSA,
  STATUS_DB.PAGO_CONFIRMADO,
  STATUS_DB.PAID,
  STATUS_DB.RELEASED,
];

export const PIX_TYPES = [
  { label: 'Email', value: 'Pix Email' },
  { label: 'Teléfono', value: 'Pix Phone' },
  { label: 'Documento', value: 'Pix Document Id' },
  { label: 'Clave aleatoria', value: 'Pix Bank Account' },
] as const;

export const STATUS_LIST = {
  PENDING_VERIFICATION: {
    text: 'En validación',
    color: PillColor.WARNING,
    groupBy: 'PROCESS',
  },
  VERIFIED: {
    text: 'Operación aprobada',
    color: PillColor.INFO,
    groupBy: 'SUCCESS',
  },
  RELEASED: {
    text: 'Operación realizada',
    color: PillColor.SUCCESS,
    groupBy: 'PROCESS',
  },
  CANCELLED: {
    text: 'Operación declinada',
    color: PillColor.ERROR,
    groupBy: 'REJECTED',
  },
  REJECTED: {
    text: 'Operación anulada',
    color: PillColor.ERROR,
    groupBy: 'REJECTED',
  },
  PAID: {
    text: 'Operación exitosa',
    color: PillColor.SUCCESS,
    groupBy: 'SUCCESS',
  },
  WAITING_RECIPIENT_ACCEPT: {
    text: 'En validación',
    color: PillColor.WARNING,
    groupBy: 'PROCESS',
  },
  CANCELLED_BY_INITIATOR: {
    text: 'Operación declinada',
    color: PillColor.ERROR,
    groupBy: 'REJECTED',
  },
  REJECTED_BY_RECIPIENT: {
    text: 'Operación anulada',
    color: PillColor.ERROR,
    groupBy: 'REJECTED',
  },
  ACCEPTED_BY_RECIPIENT: {
    text: 'Operación exitosa',
    color: PillColor.SUCCESS,
    groupBy: 'SUCCESS',
  },
  ACCEPTED_BY_INITIATOR: {
    text: 'Operación exitosa',
    color: PillColor.SUCCESS,
    groupBy: 'SUCCESS',
  },
  CANCELLED_BY_SYSTEM: {
    text: 'Operación fallida',
    color: PillColor.ERROR,
    groupBy: 'REJECTED',
  },
  ESPERANDO_PAGO: {
    text: 'Esperando pago',
    color: PillColor.WARNING,
    groupBy: 'PROCESS',
  },
  COTIZACION_VENCIDA: {
    text: 'Operación declinada',
    color: PillColor.ERROR,
    groupBy: 'REJECTED',
  },
  REVISANDO_PAGO: {
    text: 'Esperando pago',
    color: PillColor.WARNING,
    groupBy: 'PROCESS',
  },
  PAGO_CONFIRMADO: {
    text: 'Operación en curso',
    color: PillColor.INFO,
    groupBy: 'PROCESS',
  },
  EN_REVISION: {
    text: 'En validación',
    color: PillColor.WARNING,
    groupBy: 'PROCESS',
  },
  TRANSFERENCIA_ENVIADA: {
    text: 'En camino',
    color: PillColor.INFO,
    groupBy: 'PROCESS',
  },
  TRANSFERENCIA_EXITOSA: {
    text: 'Envío realizado',
    color: PillColor.SUCCESS,
    groupBy: 'SUCCESS',
  },
  DEVOLUCION_EN_PROCESO: {
    text: 'En validación',
    color: PillColor.WARNING,
    groupBy: 'PROCESS',
  },
  DEVUELTO: {
    text: 'Devolución exitosa',
    color: PillColor.INFO,
    groupBy: 'SUCCESS',
  },
  ENVIO_ANULADO: {
    text: 'Operación anulada',
    color: PillColor.ERROR,
    groupBy: 'REJECTED',
  },
  DATOS_VERIFICADOS: {
    text: 'Operación en curso',
    color: PillColor.INFO,
    groupBy: 'PROCESS',
  },
  ENVIO_RECHAZADO: {
    text: 'Operación declinada',
    color: PillColor.ERROR,
    groupBy: 'REJECTED',
  },
  UNDER_COMPLIANCE_REVIEW: {
    text: 'En validación',
    color: PillColor.WARNING,
    groupBy: 'PROCESS',
  },
} as const;
